<script lang="ts">
  // Kopf des Baums im Bereich Claude: „+" startet einen neuen Chat.
  import SymbolKnopf from "../SymbolKnopf.svelte";
  import { t } from "../i18n.svelte";
  import { navigate } from "../router.svelte";
</script>

<SymbolKnopf icon="plus" label={t("claude.neu", "Neuer Chat")} onclick={() => navigate("/claude/neu")} />
